import React from "react";
import SyntheseRecettes from "./SyntheseRecettes";
import SyntheseDepenses from "./SyntheseDepenses";
import { useSelector } from "react-redux";

const Synteses = () => {
  const { stats } = useSelector((state) => state.statsReducer);

  return (
    <div className="alignH w100 gap-4 my-2 align-items-stretch">
      <div className="flex-grow-1">
        <SyntheseRecettes stats={stats?.orderStats ?? {}} />
      </div>
      <SyntheseDepenses stats={stats?.expenseStats ?? {}} />
    </div>
  );
};

export default Synteses;
